import { Box, Typography, Button } from '@mui/material';
import Seo from '../components/Seo';
import PageShell from '../components/PageShell';
import AppStoreBadges from '../components/AppStoreBadges';

const cards = [
  { img: '/reddit.gif', title: 'Discord', link: 'https://discord.com/invite/mN8ENbzEMJ' },
  { img: '/insta.gif', title: 'Instagram', link: 'https://www.instagram.com/funizzle/' },
  { img: '/linkedin.gif', title: 'LinkedIn', link: 'https://www.linkedin.com/company/funizzle/' },
];

export default function Community() {
  return (
    <PageShell>
      <Seo
        path="/community"
        title="Community"
        description="Join the BingePlay community. Hang with indie devs and gamers on Discord, Instagram, and LinkedIn."
      />
      <Box sx={{ px: { xs: 2, sm: 4, md: 6 }, maxWidth: 1100, mx: 'auto', textAlign: 'center' }}>
        <Typography
          component="h1"
          sx={{
            color: '#fff',
            fontFamily: 'Rammetto One',
            textTransform: 'uppercase',
            fontWeight: 800,
            fontSize: { xs: 30, sm: 44, md: 56, lg: 64 },
            lineHeight: 1.1,
            mt: { xs: 2, sm: 4 },
          }}
        >
          Join the community.
        </Typography>
        <Typography
          sx={{
            color: '#ddd',
            fontFamily: 'Poppins',
            mt: { xs: 2, sm: 3 },
            fontSize: { xs: 14, sm: 18, md: 20 },
            maxWidth: 720,
            mx: 'auto',
            letterSpacing: '0.02em',
          }}
        >
          Whether you make games or play them, there&apos;s a corner of the internet for you on
          BingePlay.
        </Typography>

        <Box
          sx={{
            mt: { xs: 5, sm: 7 },
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
            gap: { xs: 2, sm: 3 },
          }}
        >
          {cards.map((c) => (
            <Box
              key={c.title}
              sx={{
                p: { xs: 3, sm: 3.5 },
                borderRadius: '20px',
                backdropFilter: 'blur(10px)',
                backgroundColor: 'rgba(255,255,255,0.1)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1.5,
              }}
            >
              <Box
                component="img"
                src={c.img}
                alt={c.title}
                sx={{ width: { xs: 100, md: 140 }, height: 'auto' }}
              />
              <Typography
                sx={{
                  color: '#fff',
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  fontSize: { xs: 18, md: 22 },
                }}
              >
                {c.title}
              </Typography>
              <Button
                href={c.link}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                sx={{
                  mt: 1,
                  width: '85%',
                  bgcolor: 'white',
                  color: '#FF2EC6',
                  textTransform: 'uppercase',
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  borderRadius: '12px',
                  py: 1,
                  '&:hover': { bgcolor: 'white' },
                }}
              >
                Join
              </Button>
            </Box>
          ))}
        </Box>

        <Box sx={{ mt: { xs: 6, sm: 8 } }}>
          <Typography
            sx={{
              color: '#fff',
              fontFamily: 'Poppins',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              fontSize: { xs: 12, sm: 14 },
            }}
          >
            Or grab the app
          </Typography>
          <AppStoreBadges />
        </Box>
      </Box>
    </PageShell>
  );
}
